import DOMPurify from "dompurify";

/** Server-side highlighting emits only <mark> (and <br> for line breaks). */
export const sanitizeHighlight = (html: string): string =>
	DOMPurify.sanitize(html, { ALLOWED_TAGS: ["mark", "br"], ALLOWED_ATTR: [] });

/** Email bodies are rich HTML: keep formatting, drop active content. */
export const sanitizeEmailHtml = (html: string): string =>
	DOMPurify.sanitize(html, {
		USE_PROFILES: { html: true },
		FORBID_TAGS: ["script", "iframe", "form", "style", "object", "embed"],
	});
